import React from "react";
import DrCard from "../components/DrCard";
import "../Styles/DrInfo.css";
import doctorList from "../contents/aboutDoctors";

const DrInfo = () => {
  return (
    <div className="dr-info-container">
      {doctorList.map((doctor, index) => (
        <div key={index} className="dr-info-card-wrapper">
          <DrCard
            name={doctor.name}
            image={doctor.image}
            designation={doctor.designation}
            speciality={doctor.speciality}
            description={doctor.description}
          />
          {index !== doctorList.length - 1 && <hr className="card-divider" />}
        </div>
      ))}
    </div>
  );
};

export default DrInfo;
